import React, {Fragment} from "react";
import {DateUtility} from "../common/DateUtility";
import {StringUtility} from "../common/StringUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {InvoiceDataUtility} from "../common/InvoiceDataUtility";
import {Constants} from "../common/Constants";

export let InvoiceFpDataDisplay = (props) => {
    let fpInvoice = props.fpInvoice;
    let lineItemsHeader = null;
    let lineItemsDisplay = null;

    function getInvoiceSubLineDisplay(subLine, phaseIndex, subLineIndex, serviceType) {
        let subLineClass = InvoiceDataUtility.fpServiceTypeToClass(serviceType);
        let subLineDescriptionDisplay = null;
        if (subLine.description) {
            subLineDescriptionDisplay = (
                <div className="invoice-sub-line-description">
                    {subLine.description}
                </div>
            )
        }
        return (
            <div
                id={`fpInvoiceLine-${(phaseIndex + 1)}-${(subLineIndex + 1)}`}
                key={`${phaseIndex}-${subLineIndex}`}
                className={`invoice-sub-line ${subLineClass}`}
            >
                <div className="invoice-sub-line-summary">
                    <div className="invoice-sub-line-summary-content">
                        <div className="invoice-sub-line-summary-label">
                            <div className="invoice-sub-line-name">
                                {subLine.name}
                            </div>
                            <div className={`invoice-sub-line-type fp-invoice-line-type-badge ${subLineClass}`}>
                                {serviceType}
                            </div>
                        </div>
                        <div className="invoice-sub-line-summary-value">
                            {StringUtility.stringNumberToDisplayCurrency(subLine.total)}
                        </div>
                    </div>
                </div>
                {subLineDescriptionDisplay}
            </div>
        )
    }

    let lineTotal = 0.0;
    if (
        fpInvoice.invoiceFinancialDetails &&
        fpInvoice.invoiceFinancialDetails.estimatePhases
    ) {
        lineItemsHeader = (
            <div className="invoice-line-items-header">
                <div className="invoice-line-items-header-content">
                    <div className="invoice-line-items-header-left">Scope Of Work</div>
                    <div className="invoice-line-items-header-right">Cost</div>
                </div>
            </div>
        )

        let lineItems = [];
        fpInvoice.invoiceFinancialDetails.estimatePhases.forEach((estimatePhase, phaseIndex) => {
            let subLinesDisplay = [];
            let indexInPhase = 0;
            if (estimatePhase.IS) {
                estimatePhase.IS.forEach((subLine, subLineIndex) => {
                    lineTotal += parseFloat(subLine.total);
                    subLinesDisplay.push(getInvoiceSubLineDisplay(
                        subLine, phaseIndex, indexInPhase, Constants.fpServiceTypeNames.internalService
                    ));
                    indexInPhase++
                })
            }
            if (estimatePhase.IE) {
                estimatePhase.IE.forEach((subLine, subLineIndex) => {
                    lineTotal += parseFloat(subLine.total);
                    subLinesDisplay.push(getInvoiceSubLineDisplay(
                        subLine, phaseIndex, indexInPhase, Constants.fpServiceTypeNames.internalExpense
                    ));
                    indexInPhase++
                })
            }
            if (estimatePhase.EE) {
                estimatePhase.EE.forEach((subLine, subLineIndex) => {
                    lineTotal += parseFloat(subLine.total);
                    subLinesDisplay.push(getInvoiceSubLineDisplay(
                        subLine, phaseIndex, indexInPhase, Constants.fpServiceTypeNames.externalExpense
                    ));
                    indexInPhase++
                })
            }

            lineItems.push(
                <div
                    id={`fpInvoicePhaseLine-${(phaseIndex + 1)}`}
                    key={phaseIndex}
                    className="invoice-line-item"
                >
                    <div className="invoice-line-item-summary">
                        <div className="invoice-line-item-summary-content">
                            <div className="invoice-line-item-summary-left">
                                {estimatePhase.name}
                            </div>
                            <div className="invoice-line-item-summary-right">
                                {StringUtility.stringNumberToDisplayCurrency(estimatePhase.total)}
                            </div>
                        </div>
                    </div>
                    <div className="invoice-line-item-detail">
                        <div className="invoice-line-item-description">
                            {estimatePhase.description}
                        </div>
                        <div className="invoice-line-item-details">
                            {subLinesDisplay}
                        </div>
                    </div>
                </div>
            );
        });
        lineItemsDisplay = (
            <div className="invoice-line-items-list">{lineItems}</div>
        )
    }

    let lineTotalDisplay = null;
    if (lineTotal !== parseFloat(fpInvoice.total)) {
        lineTotalDisplay = (
            <ReadInvoiceDetailHorizontal
                label="Line Total"
                value={StringUtility.stringNumberToDisplayCurrency(fpInvoice.total)}
                additionalClasses="invoice-line-total"
            />
        )
    }

    return (
        <Fragment>
            <div className="single-invoice-row">
                <div className="single-invoice-row-content">
                    <div className="single-invoice-row-part">
                        <div className="single-invoice-row-part-content">
                            <div className="single-invoice-details-section">
                                <ReadInvoiceDetailHorizontal
                                    value={
                                        fpInvoice.invoicecompany.companyname +
                                        ' (' +
                                        (fpInvoice.invoicecontact ? fpInvoice.invoicecontact.contactFullName : 'No contact') +
                                        ')'
                                    }
                                    additionalClasses="company"
                                />
                                <ReadInvoiceDetailHorizontal
                                    label="Date"
                                    value={DateUtility.fpDateToLocalTextDate(fpInvoice.invoicedate)}
                                    additionalClasses="date"
                                />
                            </div>
                            <div className="single-invoice-details-section">
                                <ReadInvoiceDetailHorizontal
                                    label="Project Name"
                                    value={fpInvoice.invoiceproject.projectname}
                                    additionalClasses="project-name"
                                />
                                <ReadInvoiceDetailHorizontal
                                    label="Title"
                                    value={fpInvoice.docket.name}
                                    additionalClasses="title"
                                />
                                <ReadInvoiceDetailHorizontal
                                    label="Job"
                                    value={fpInvoice.docket.number}
                                    additionalClasses="job"
                                />
                                <ReadInvoiceDetailHorizontal
                                    label="Type"
                                    value={fpInvoice.invoicetype}
                                    additionalClasses="type"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="single-invoice-row-part date-details">
                        <div className="single-invoice-row-part-content">
                            <ReadInvoiceDetailHorizontal
                                label="Created"
                                value={DateUtility.fpDateToLocalTextDate(fpInvoice.datecreated)}
                                additionalClasses="created"
                            />
                            <ReadInvoiceDetailHorizontal
                                label="Last Updated"
                                value={DateUtility.fpDateToLocalTextDate(fpInvoice.datemodified)}
                                additionalClasses="last-updated"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="single-invoice-row">
                <ReadInvoiceDetailVertical
                    label="Description"
                    value={fpInvoice.description}
                    additionalClasses="description"
                />
            </div>

            <div className="single-invoice-row line-items-row">
                {lineItemsHeader}
                {lineItemsDisplay}
            </div>

            <div className="single-invoice-row">
                <div className="single-invoice-row-content">
                    <div className="single-invoice-row-part bottom-details">
                        <div className="single-invoice-row-part-content">
                            <div className="single-invoice-details-section">
                                {lineTotalDisplay}
                                <ReadInvoiceDetailHorizontal
                                    label="Total"
                                    value={StringUtility.stringNumberToDisplayCurrency(fpInvoice.total)}
                                    additionalClasses="invoice-total"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

let ReadInvoiceDetailHorizontal = function (props) {
    return (
        <div className={`single-invoice-detail ${props.additionalClasses || ''}`}>
            <div className="single-invoice-detail-content">
                <ConditionalRenderer if={props.label} renderer={() => (
                    <div className="single-invoice-detail-label">{props.label}:</div>
                )}/>
                <div className="single-invoice-detail-value">{props.value}</div>
            </div>
        </div>
    )
}

let ReadInvoiceDetailVertical = function (props) {
    return (
        <div className={`single-invoice-detail-vertical ${props.additionalClasses || ''}`}>
            <ConditionalRenderer if={props.label} renderer={() => (
                <div className="single-invoice-detail-label">{props.label}:</div>
            )}/>
            <div className="single-invoice-detail-value">{props.value}</div>
        </div>
    )
}
